module.exports = __webpack_public_path__ + "img/Lisa-ZWEI.b91c88d3.jpg";